.shell {
  height: 100%;
  display: flex; flex-direction: column;
  background: radial-gradient(circle at top, #0c121d 0%, var(--bg-base) 60%);
}
.main {
  flex: 1;
  overflow: hidden;
  display: flex;
}
